'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentVisaLogoAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M37.2957 39.7782H31.7032L35.2011 19.4772H40.7933L37.2957 39.7782Z",
          fill: "#15195A"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M57.5686 19.9734C56.4655 19.5627 54.7159 19.1091 52.5525 19.1091C47.0298 19.1091 43.1407 21.8734 43.1168 25.8254C43.0709 28.7412 45.9013 30.3608 48.0182 31.333C50.1818 32.3264 50.9173 32.9749 50.9173 33.8604C50.8953 35.2204 49.169 35.8473 47.5588 35.8473C45.3261 35.8473 44.1297 35.5241 42.3116 34.7675L41.5752 34.4431L40.7926 39.0003C42.1043 39.5611 44.5208 40.0589 47.0298 40.0807C52.8978 40.0807 56.7181 37.3592 56.7633 33.1477C56.7857 30.8367 55.2911 29.0659 52.069 27.6189C50.113 26.69 48.9151 26.0637 48.9151 25.1133C48.9381 24.2493 49.9283 23.3643 52.1363 23.3643C53.9544 23.321 55.2902 23.7311 56.3022 24.1416L56.808 24.3572L57.5686 19.9734Z",
          fill: "#15195A"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M67.5793 19.4772H71.9051L76.4168 39.7779H71.2387C71.2387 39.7779 70.732 37.4454 70.5714 36.7326H63.3911C63.1835 37.2723 62.2174 39.7779 62.2174 39.7779H56.3494L64.6563 21.1616C65.2319 19.844 66.2453 19.4772 67.5793 19.4772ZM67.2348 26.9062C67.2348 26.9062 65.4625 31.42 65.002 32.5863H69.6504C69.4204 31.5713 68.3614 26.7119 68.3614 26.7119L67.9706 24.9626C67.806 25.4131 67.568 26.0324 67.4074 26.4501C67.2986 26.7332 67.2254 26.9237 67.2348 26.9062Z",
          fill: "#15195A"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.47166 19.4772H16.4694C17.689 19.5199 18.6787 19.8871 19.0007 21.1837L20.956 30.5102C20.9562 30.5111 20.9565 30.512 20.9568 30.5129L21.5553 33.3205L27.0322 19.4772H32.9458L24.1554 39.7567H18.2415L13.2569 22.1169C11.537 21.1732 9.57418 20.4141 7.37961 19.8874L7.47166 19.4772Z",
          fill: "#15195A"
        }
      )
    ]
  }
);
const VpPaymentVisaLogoAsset = forwardRef(PaymentVisaLogoAsset);

export { VpPaymentVisaLogoAsset as default };
